import { Component, OnInit } from '@angular/core';
import { CemeteryService } from '../../../services/cemetery.service';
import { Cemetery } from '../../../models/cemetery.model';

@Component({
  selector: 'app-partnered',
  templateUrl: './partnered.component.html',
  styleUrls: ['./partnered.component.scss']
})
export class PartneredComponent implements OnInit {
  cemeteries: Cemetery[] = [];
  selectedCemeteryId: string | null = null;

  constructor(private cemeteryService: CemeteryService) {}

  ngOnInit(): void {
    this.cemeteries = this.cemeteryService.getCemeteries();
    this.cemeteryService.selectedCemetery$.subscribe(id => {
      this.selectedCemeteryId = id;
    });
  }

  selectCemetery(id: string): void {
    this.cemeteryService.setSelectedCemetery(id === this.selectedCemeteryId ? null : id);
  }

  isSelected(id: string): boolean {
    return this.selectedCemeteryId === id;
  }

  hasOnlineOrder(cemetery: Cemetery): boolean {
    return cemetery.documents.some(doc => doc.isOnlineOrder);
  }
}
